var _ = require('underscore'),
	ValidationError = require('../../../core/errors/ValidationError'),
	validationUtilities = require('../../../util/validationUtilities'),
	apiDefinitions = require('../../../services/api/core/apiDefinitions');

var MAX_STRING_LENGTH = apiDefinitions.validation.max;

function checkMin(target, value) {
	var typeofValue = typeof value;

	if (typeofValue === 'string') {
		return value.length >= target;
	} else if (typeofValue === 'number') {
		return value >= target;
	} else {
		return false;
	}
}

function checkMax(target, value) {
	var typeofValue = typeof value;

	if (typeofValue === 'string') {
		return value.trim().length <= target;
	} else if (typeofValue === 'number') {
		return value <= target;
	} else {
		return false;
	}
}

module.exports = function (definition, params) {
	var spec = definition.spec,
		isGet = definition.method.toLowerCase() === 'get',
		required = [],
		notAllowed = [],
		invalid = [];

	validationUtilities.whitelistVisitor(spec, params, function (key, isInSpec, value, isArrayMember) {
		if (isArrayMember) {
			// Not validating array members yet
			return;
		}

		if (!isInSpec) {
			notAllowed.push(key);
		} else {
			var typeofValue = typeof value,
				typeofCastedValue = typeofValue,
				specForKey = spec[key],
				specType = specForKey.type;

			if (typeofValue === 'number') {
				value = String(value);

				typeofCastedValue = typeof value;
			} else if (specType === 'number' && !isNaN(value)) {
				typeofCastedValue = 'number';
			} else if (specType === 'boolean' && (value === 'true' || value === 'false')) {
				typeofCastedValue = 'boolean';
			} else if (specType === 'array' && typeofValue !== 'undefined') {
				typeofValue = 'array';

				if (!(value instanceof Array)) {
					params[key] = value = [value];
				}
			} else if (isGet && specType === 'object') {
				if (value !== null && typeofValue === 'object') {
					params[key] = value = JSON.stringify(value);
				} else if (typeofValue === 'string') {
					params[key] = value = JSON.parse(value);
					typeofCastedValue = 'object';
				}
			}

			if (value !== null && typeofValue !== 'undefined') {
				if (typeofValue !== specType && typeofCastedValue !== specType) {
					invalid.push(key);
				} else if (typeofCastedValue === 'string' && value.length > MAX_STRING_LENGTH) {
					invalid.push(key);
				} else if (specForKey.domain) {
					if (typeofValue === 'array') {
						if (
							_.some(value, function (v) {
								return !(v in specForKey.domain);
							})
						) {
							invalid.push(key);
						}
					} else if (!(value in specForKey.domain)) {
						invalid.push(key);
					}
				} else if (
					specForKey.min &&
					(typeofValue === 'array'
						? !_.every(value, checkMin.bind(this, specForKey.min))
						: !checkMin(specForKey.min, specType === 'number' ? Number(value) : value))
				) {
					invalid.push(key);
				} else if (
					specForKey.max &&
					(typeofValue === 'array'
						? !_.every(value, checkMax.bind(this, specForKey.max))
						: !checkMax(specForKey.max, specType === 'number' ? Number(value) : value))
				) {
					invalid.push(key);
				} else if (
					specForKey.regexp &&
					(typeofValue === 'array' ? !_.every(value, specForKey.regexp.test.bind(specForKey.regexp)) : !specForKey.regexp.test(value))
				) {
					invalid.push(key);
				}
			}
		}
	});

	var isPresent;

	if (isGet) {
		isPresent = function (key, value) {
			return value[key] !== null && typeof value[key] !== 'undefined' && value[key] !== '';
		};
	} else {
		isPresent = function (key, value) {
			return value[key] !== null && typeof value[key] !== 'undefined';
		};
	}

	for (var key in spec) {
		if (spec[key].required) {
			(function match(k, v) {
				if (k.indexOf('.') === -1) {
					if (!isPresent(k, v)) {
						required.push(k);
					}
				} else {
					var keyTokens = k.split('.'),
						firstToken = keyTokens[0];

					if (isPresent(firstToken, v)) {
						keyTokens.shift();

						match(keyTokens.join('.'), v[firstToken]);
					} else {
						required.push(k);
					}
				}
			})(key, params);
		}
	}

	if (required.length || notAllowed.length || invalid.length) {
		return new ValidationError({
			r: required,
			i: invalid,
			n: notAllowed
		});
	}
};
